// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCJIQLrfVdtP6GRm6OFBD5SK-x6acEiXWA",
  authDomain: "ksapp-38a7c.firebaseapp.com",
  projectId: "ksapp-38a7c",
  storageBucket: "ksapp-38a7c.appspot.com",
  messagingSenderId: "892791647475",
  appId: "1:892791647475:web:549fc41189c25a89d25b86",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db, storage, auth };
